<!--
 * @Description: 
 * @Date: 2021-07-19 16:35:52
-->
<template>
  <div class="box">
    <el-form :model="formParams" ref="form" label-position="top">
      <div
        class="flex"
        v-for="{ title, subTitle, list } in form.filter(i => !i.hide)"
        :key="title"
      >
        <div class="app-detail-item-title">
          <span>{{ title }}</span>
          <span
            style="font-size: 12px;margin-top: 4px;margin-left: 5px;color:#9c9c9c;"
          >
            {{ subTitle }}
          </span>
        </div>
        <el-form-item
          :label="item.label"
          v-for="item in list"
          :label-width="item.label ? '130px' : '0'"
          :style="{ width: item.width }"
          :key="item.key"
          :prop="item.key"
          :rules="item.rules || []"
        >
          <template v-if="item.slot === 'dicSelect'">
            <dic-select
              style="width:100%;"
              :key="dicSelectKeys[item.key]"
              @dic-select-obj="
                val => {
                  item.callback && item.callback();
                  formParams[item.key] = val[item.attrs.useValueKey];
                  item.key1 &&
                    item.attrs.useValueKey1 &&
                    (formParams[item.key1] = val[item.attrs.useValueKey1]);
                }
              "
              :fuzzyDef="item.selectAjax"
              v-bind="item.attrs"
              :placeholder="item.placeholder"
              class="data-item"
            ></dic-select>
          </template>
          <template v-if="item.slot === 'input'">
            <el-tooltip
              class="item"
              effect="dark"
              :content="formParams[item.key]"
              :disabled="!(item.attrs || {}).disabled || !formParams[item.key]"
              placement="top-start"
            >
              <el-input
                :placeholder="item.placeholder"
                v-model="formParams[item.key]"
                v-bind="item.attrs"
                v-on="item.listeners"
                class="data-item"
              />
            </el-tooltip>
          </template>
          <template v-if="item.slot === 'date'">
            <el-date-picker
              :placeholder="item.placeholder"
              :value-format="item.valueFormat"
              v-model="formParams[item.key]"
              class="data-item"
              :type="item.type || 'month'"
            ></el-date-picker>
          </template>
          <template v-if="item.slot === 'custom'">
            <component
              :ref="item.ref"
              :is="item.component"
              :value="formParams[item.key]"
              v-bind="item.attrs"
              v-on="item.listeners"
            ></component>
          </template>
        </el-form-item>
      </div>
    </el-form>
    <div style="text-align: center;padding-bottom:15px;">
      <template v-if="needVerify">
        <el-button type="primary" @click="confirm">确定</el-button>
        <el-button @click="noPass">驳回</el-button>
      </template>
      <template v-else>
        <el-button @click="$xrkDialog.remove()">关闭</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import Vue from 'vue';
import store from '@/store/index.js';
import router from '@/router/index';
import { moneyInt } from '@/tools/money';
import { invoice } from '@/api/ajax';
import dicSelect from '@/components/Common/dicSelect.vue';
import OpenNewWin from '@/tools/openNewWin';

const createComponent = component => {
  const Constructor = Vue.extend({ ...component, store, router });
  let instances = new Map();
  const remove = uid => {
    return () => {
      let instancesSize = instances.size;
      if (!instancesSize) {
        throw new Error('没有 ElImageViewer实例');
      }
      let keys = [...instances.keys()];
      let lastKey = keys[keys.length - 1];
      let example = instances.get(uid || lastKey); // 如果没有uid则删除最后一个
      document.getElementById('app').removeChild(example.$el);
      example.$destroy();
      instances.delete(example._uid);
    };
  };
  const initInstance = () => {
    let instance = new Constructor({
      el: document.createElement('div')
    });
    let { _uid } = instance;
    instances.set(_uid, instance);
    instance.remove = remove(_uid);
    return instance;
  };
  const ElImageViewer = options => {
    let instance = initInstance();
    for (let prop in options) {
      if (options.hasOwnProperty(prop)) {
        instance[prop] = options[prop];
      }
    }
    instance.$mount();
    document.getElementById('app').appendChild(instance.$el);
    Vue.nextTick(() => {
      instance.visible = true;
    });
    return instance;
  };
  ElImageViewer.clear = () => {
    instances.forEach(item => {
      document.getElementById('app').removeChild(item.$el);
      item.$destroy();
    });
    instances.clear();
  };
  ElImageViewer.remove = remove();
  return ElImageViewer;
};

/**
 * 点击蒙版关闭 preview-src-list 的图片预览
 */
const handleClickItem = ctx => {
  ctx.$nextTick(() => {
    let domImageMask = document.querySelector('.el-image-viewer__mask'); // 获取遮罩层dom
    if (!domImageMask) {
      return;
    }
    domImageMask.addEventListener('click', () => {
      // 点击遮罩层时调用关闭按钮的 click 事件
      document.querySelector('.el-image-viewer__close').click();
    });
  });
};
const customImageViewer = createComponent(ElImageViewer);

export default {
  name: 'add-dutypaid-proof',
  components: { dicSelect },
  props: { id: [Number, String], invoiceStatus: [Number, String] },
  data() {
    return {
      dicSelectKeys: {
        itemId: 1
      },
      formParams: {
        csoEnterpriseId: '',
        address: []
      }
    };
  },
  computed: {
    needVerify() {
      return this.invoiceStatus == 2;
    },
    form() {
      const {
        formParams: { fileList = [], picList = [] }
      } = this;
      return [
        {
          title: '发票信息',
          list: [
            {
              label: '开票服务商',
              slot: 'input',
              key: 'csoEnterpriseName',
              attrs: {
                disabled: true
              }
            },
            {
              label: '发票类别',
              slot: 'input',
              key: 'invoiceTypeName',
              attrs: {
                disabled: true
              }
            },
            {
              label: '开票类目',
              slot: 'input',
              key: 'itemName',
              attrs: {
                disabled: true
              }
            },
            {
              label: '开票金额（元）',
              slot: 'input',
              key: 'invoiceAmount',
              attrs: {
                disabled: true
              }
            }
          ]
        },
        {
          title: '开票信息',
          list: [
            {
              label: '发票抬头',
              slot: 'input',
              key: 'enterpriseName',
              attrs: {
                disabled: true
              }
            },
            {
              label: '纳税人识别号',
              slot: 'input',
              key: 'invoiceIdentifierNo',
              attrs: {
                disabled: true
              }
            },
            {
              label: '联系电话',
              slot: 'input',
              key: 'invoicePhone',
              attrs: {
                disabled: true
              }
            },
            {
              label: '开户银行',
              slot: 'input',
              key: 'invoiceOpenBank',
              attrs: {
                disabled: true
              }
            },
            {
              label: '银行账号',
              slot: 'input',
              key: 'invoiceBankNo',
              attrs: {
                disabled: true
              }
            },
            {
              label: '企业地址',
              slot: 'input',
              key: 'invoiceEnterpriseAddress',
              attrs: {
                disabled: true
              }
            }
          ]
        },
        {
          title: '发票邮寄地址',
          list: [
            {
              label: '收件人',
              slot: 'input',
              key: 'receiptFullName',
              attrs: {
                disabled: true
              }
            },
            {
              label: '联系电话',
              slot: 'input',
              key: 'receiptPhone',
              attrs: {
                disabled: true
              }
            },
            {
              label: '邮寄地址',
              slot: 'input',
              key: 'receiptAddress',
              attrs: {
                disabled: true
              }
            }
          ]
        },
        {
          title: '上传发票',
          hide: picList.length == 0,
          list: [
            {
              width: '100%',
              slot: 'custom',
              key: 'fileList',
              component: {
                render() {
                  const formItemStyle =
                    'width: 200px;margin-bottom: 15px;margin-right: 25px;';
                  return (
                    <div style="display: flex;flex-wrap: wrap;">
                      {picList.map((item, index) => {
                        return (
                          <div style={formItemStyle}>
                            <el-image
                              style="width:100%;height:270px;"
                              src={item.invoicePic}
                              onClick={() => {
                                const prevOverflow =
                                  document.body.style.overflow;
                                document.body.style.overflow = 'hidden';
                                customImageViewer({
                                  onClose: () => {
                                    document.body.style.overflow = prevOverflow;
                                    customImageViewer.remove();
                                  },
                                  zIndex: 3000,
                                  urlList: picList.map(item => item.invoicePic),
                                  index: index
                                });
                                handleClickItem(this.$parent);
                              }}
                            ></el-image>
                            <el-input
                              disabled
                              v-model={item.invoiceNo}
                              style="margin-top:10px;"
                            />
                          </div>
                        );
                      })}
                    </div>
                  );
                }
              }
            }
          ]
        },
        {
          title: '上传附件',
          hide: fileList.length == 0,
          list: [
            {
              width: '100%',
              slot: 'custom',
              key: 'fileList',
              component: {
                render() {
                  return (
                    <div>
                      {(fileList || [])
                        .filter(item => item)
                        .map(item => {
                          return (
                            <p>
                              <el-button
                                type="text"
                                onClick={() => {
                                  const newWin = new OpenNewWin();
                                  newWin.createWin();
                                  newWin.setUrl(item.fileUrl);
                                }}
                              >
                                {item.fileName}
                              </el-button>
                            </p>
                          );
                        })}
                    </div>
                  );
                }
              }
            }
          ]
        }
      ];
    }
  },
  methods: {
    verify(status, text) {
      invoice
        .auditInvoice({
          id: this.id,
          invoiceStatus: status,
          noPassReason: text
        })
        .then(() => {
          this.$emit('confirm');
          this.$message.success(status == 4 ? '确认成功' : '驳回成功');
          this.$xrkDialog.remove();
        });
    },
    confirm() {
      this.verify(4);
    },
    noPass() {
      this.$prompt('请输入驳回原因', '驳回', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.verify(3, value);
      });
    },
    async getInvioceInfo() {
      const {
        data: { data }
      } = await invoice.detail({ id: this.id });
      const {
        invoiceTypeName,
        itemName,
        csoEnterpriseName,
        invoiceAmount,
        receiptFullName,
        receiptPhone,
        receiptAddress,
        enterpriseName,
        invoiceIdentifierNo,
        invoicePhone,
        invoiceOpenBank,
        invoiceBankNo,
        invoiceEnterpriseAddress,
        fileList,
        picList
      } = data;
      this.formParams = {
        invoiceTypeName,
        itemName,
        csoEnterpriseName,
        invoiceAmount: moneyInt(invoiceAmount),
        receiptFullName,
        receiptPhone,
        receiptAddress,
        enterpriseName,
        invoiceIdentifierNo,
        invoicePhone,
        invoiceOpenBank,
        invoiceBankNo,
        invoiceEnterpriseAddress,
        fileList,
        picList
      };
    }
  },
  async created() {
    this.getInvioceInfo();
  }
};
</script>
<style lang="scss" scoped>
.box {
  .flex {
    display: flex;
    flex-wrap: wrap;
    .app-detail-item-title {
      font-size: 18px;
      width: 100%;
      margin-bottom: 30px;
    }
  }
  .el-form {
    &-item {
      width: 250px;
      margin-bottom: 25px;
      margin-right: 25px;
    }
  }
}
</style>
